import * as userActions from 'app/Core/Funcionalidade/Auth/store/actions';
import FirebaseAuthService from 'app/Core/services/FirebaseAuthService';
import * as AppActions from 'app/store/actions';
import history from 'history.js';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FuseSplashScreen from '../../../../@fuse/components/FuseSplashScreen/FuseSplashScreen';

class Auth extends Component {

    // componentDidMount() {
    //     if (sessionStorage.getItem('google_access_token') !== undefined &&
    //         sessionStorage.getItem('google_access_token') !== null &&
    //         sessionStorage.getItem('google_access_token').length > 0) {
    //         const jwt_access_token = FirebaseAuthService.getAccessToken();
    //         if(jwt_access_token === undefined || jwt_access_token === null)
    //         {
    //         this.Autenticar();
    //         }
    //         else
    //         {
    //             this.ValidarToken();
    //         }
    //     }
    // }


    ValidarToken = () => {
        this.setState({ Preload: 1 });
        FirebaseAuthService.signInWithToken()
            .then(resp => {
                this.props.setUserData(resp.user, resp.access_token, resp.status_xapp);
                if (resp.user.data.settings !== null)
                    this.props.setNavigation(resp.user.data.settings);
            })
            .catch(error => {
                history.push("/pub-login");
                this.showMessageAutenticacao(error);
            })
            .finally(() => {
                this.setState({ Preload: 0 });
            })
    }

    showMessageAutenticacao = (message) => {
        var AMensagem = message;
        if (message === 'Network Error') {
            AMensagem = 'Servidor indisponível!'
        }
        else if (message.toString().includes("code 500")) {
            AMensagem = 'Servidor indisponível!'
        }
        else if (message.toString().includes("Sessão expirada")) {
            AMensagem = null;
        }

        if (AMensagem !== null) {
            this.props.showMessage({
                message: AMensagem,
                variant: 'error'
            });
        }
    }

    render() {
        const { children, Preload } = this.props;

        return (
            <React.Fragment>
                {Preload === 1 ?
                    <FuseSplashScreen />
                    :
                    children
                }
            </React.Fragment>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setUserData: userActions.setUserData,
        showMessage: AppActions.showMessage,
        hideMessage: AppActions.hideMessage,
        setNavigation: AppActions.setNavigation,
    },
        dispatch);
}

function mapStateToProps({ auth }) {
    return {
        jwt_access_token: auth.user.data.access_token,
        settings: auth.user.data.settings,
        Preload: auth.user.preload
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);

